module.exports = __webpack_public_path__ + "media/images/icons/fr-40c79af5ce5231775ae018679c075255.svg";